<template>
<div class="pagination-outer">
  <div class="total-pages-count">Page {{ pagination.current_page }} of {{ pagination.total_pages }}</div>
  <ul class="pagination-wrapper">
    <li v-if="pagination.current_page > 1">
      <a href="javascript:void(0)" aria-label="Previous" v-on:click.prevent="changePage(pagination.current_page - 1)">
      <span aria-hidden="true">«</span>
      </a>
    </li>
    <li v-for="page in pagesNumber" :key="page" :class="{'active': page == pagination.current_page}">
    <a href="javascript:void(0)" v-on:click.prevent="changePage(page)">{{ page }}</a>
    </li>
    <li v-if="pagination.current_page < pagination.total_pages">
      <a href="javascript:void(0)" aria-label="Next"
       v-on:click.prevent="changePage(pagination.current_page + 1)">
      <span aria-hidden="true">»</span>
      </a>
    </li>
  </ul>
</div>
</template>
<script>
export default {
  name: 'Pagination',
  props: {
    pagination: {
      type: Object,
      required: true
    },
    offset: {
      type: Number,
      default: 4
    }
  },
  computed: {
    pagesNumber () {
      let from = this.pagination.current_page - this.offset
      if (from < 1) {
        from = 1
      }
      let nextPage = from + this.offset * 2
      if (nextPage >= this.pagination.total_pages) {
        nextPage = this.pagination.total_pages
      }
      let pagesArray = []
      for (let page = from; page <= nextPage; page++) {
        pagesArray.push(page)
      }
      return pagesArray
    }
  },
  methods: {
    changePage (page) {
      this.pagination.current_page = page
      this.$emit('paginate', this.pagination.current_page)
    }
  }
}
</script>

<style lang="scss" scopped>
.pagination-wrapper {
  margin: 25px 0 0 0;
  padding: 0;
  list-style: none;
  text-align: right;
  font-size: 14px;
  display: inline-block;
  width: 85%;
  li {
    margin: 0 5px;
    display: inline-block;
    a {
      text-decoration: none;
      color: #0059AE;
    }
    &.active {
      a {
        border-bottom: 1px solid #0059AE;
      }
    }
    &:hover {
      opacity: 0.8;
    }
  }
}
.total-pages-count {
  display: inline-block;
  width: 15%;
  font-size: 14px;
}
</style>